import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBenchmarkResult,
  BackendMutationExtractPerformanceCenterBenchmarksArgs,
} from 'src/types/backend';

import { COMPARISON_SET_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractPerformanceCenterBenchmarks(
    $projectId: ID!
    $text: String!
    $assetType: AssetTypeEnum!
    $adAccountId: ID
    $userGoal: String
    $variationId: ID
    $comparisonSetName: String
  ) {
    extractPerformanceCenterBenchmarks(
      projectId: $projectId
      text: $text
      assetType: $assetType
      adAccountId: $adAccountId
      userGoal: $userGoal
      variationId: $variationId
      comparisonSetName: $comparisonSetName
    ) {
      account {
        id
        name
        channel
      }
      position
      customScore
      comparisonSet {
        ...ComparisonSet
      }
    }
  }
  ${COMPARISON_SET_FRAGMENT}
`;

type Variables = BackendMutationExtractPerformanceCenterBenchmarksArgs;
type Result = BackendBenchmarkResult;

export const extractPerformanceCenterBenchmarks = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
